module.exports = __webpack_public_path__ + "static/image20-4ea31f95640015ce64d9b45064f2f7f8.jpg";